export default __webpack_public_path__ + "static/media/carnet-de-identidad.9ff75721.svg";